import type { PropsWithChildren } from "react";
import React from "react";

interface RequestSidebarItemProps {
  title: string;
}

const RequestSidebarItem: React.FC<
  PropsWithChildren<RequestSidebarItemProps>
> = ({ title, children }) => {
  return (
    <div className="request-sidebar-item">
      <h4>{title}</h4>
      <div className="request-sidebar-item-content">{children}</div>
    </div>
  );
};

export { RequestSidebarItem };
